/*
 *   File : alphabasket.js
 *   Author : https://evoqins.com
 *   Description : AlphaBasket card component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React from 'react';
import { useNavigate } from 'react-router-dom';

//Style
import style from "../../Styles/Component/card.module.scss";

//Custom component
import { Chip } from '../Others';
import { Icon } from '../Icon';
import { PrimaryButton } from '../Buttons';

const AlphaBasketCard = (props) => {

    const navigate = useNavigate();

    // handle navigate to creator detail page
    const _handleNavigateToCreatorDetail = (event, creator_id) => {
        navigate("/explore/creator-detail", {
            state: {
                creator_id: Number(creator_id)
            }
        });
        event.stopPropagation();
    };

    return (
        props.type == 1 ?
            <div className={`${style.e_alphabasket_card_wrapper} cursor-pointer h-100`}
                onClick={() => props.handleClick()}>
                <div className='e-bg-white border-radius-16 h-100'>
                    <div data-type={props.category === 1 ? "basket" : "basket-pro"}
                        className={`${style.e_heading_wrapper} position-relative`}>
                        <img src={require(props.category === 1 ? "../../Assets/Images/Card/alphabasket-tag.svg" : "../../Assets/Images/Card/alphabasket-pro-tag.svg").default}
                            draggable={false}
                            className='position-absolute left--6px top-8px h-28'
                            alt='tag' />
                        {
                            props.product.risk_category_info?.risk_category_name &&
                            <Chip label={props.product.risk_category_info?.risk_category_name}
                                className={props.product.risk_category_info?.risk_category_name === 'Conservative' ? 'e-text-deep-green e-bg-nyanza e-border-1px-light-green' :
                                    props.product.risk_category_info?.risk_category_name === 'Moderate' ? 'e-text-brown e-bg-lemon-chiffon e-border-1px-jasmine' :
                                        'e-text-cadmium-purple e-bg-lavender-blush e-border-1px-light-red'} />
                        }
                    </div>
                    <div className='p-3'>
                        <div className='d-flex align-items-center gap-12px e-border-bottom-1px-anti-flash-white pb-3'>
                            <img src={props.product.strategy_icon}
                                draggable={false}
                                className={`${props.product.strategy_icon ? "" : "invisible"} border-radius-4 bg-white object-fit-contain`}
                                width={48}
                                alt={props.product.strategy_name} />
                            <div>
                                <p className='e-font-14-res mb-1 e-text-black e-alt-font-lato e-font-16 e-font-weight-600 line-height-20px'>
                                    {props.product.strategy_name}
                                </p>
                                {
                                    props.product.creator_info.creator_name &&
                                    <span className='e-font-12-res mb-0 e-text-philippine-gray e-alt-font-lato e-font-14 e-font-weight-400 line-height-18px text-decoration-hover-underline'
                                        onClick={(event) => _handleNavigateToCreatorDetail(event, props.product.creator_info.creator_id)}>
                                        by {props.product.creator_info.creator_name || "--"}
                                    </span>
                                }
                            </div>
                        </div>

                        {/* basket details */}
                        <div className='pt-2'>
                            <div className='row justify-content-between'>
                                {
                                    props.product.returns &&
                                    <div className='col-3'>
                                        <p className='mb-1 e-text-outer-space e-alt-font-lato e-font-12 e-font-weight-400 line-height-18px'>
                                            {props.product.returns.label}
                                        </p>
                                        <p className={`${props.product.returns.value >= 0 ? "e-text-islamic-green-light" : "e-text-red"} e-font-14-res mb-0 e-alt-font-lato e-font-16 e-font-weight-600 line-height-20px`}>
                                            {props.product.returns.value_str}
                                        </p>
                                    </div>
                                }
                                <div className='col-5'>
                                    <p className='mb-1 e-text-outer-space e-alt-font-lato e-font-12 e-font-weight-400 line-height-18px'>
                                        Objective
                                    </p>
                                    <p className={`e-font-14-res mb-0 e-text-chinese-black e-alt-font-lato e-font-16 e-font-weight-600 line-height-20px`}>
                                        {props.product.objective}
                                    </p>
                                </div>
                                <div className='col-4 text-end'>
                                    <p className='mb-1 e-text-outer-space e-alt-font-lato e-font-12 e-font-weight-400 line-height-18px'>
                                        Min. Investment
                                    </p>
                                    {
                                        props.product.min_investment &&
                                        <p className={`e-font-14-res mb-0 e-text-chinese-black e-alt-font-lato e-font-16 e-font-weight-600 line-height-20px`}>
                                            ₹{Number(props.product.min_investment).toLocaleString("en-IN")}
                                        </p>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            :
            props.type === 2 ?
                <div className={`${style.e_alphabasket_card_wrapper} cursor-pointer`}
                    onClick={props.onClick}>
                    <div className='e-bg-white border-radius-16'>
                        <div data-type={props.product.strategy_type === "alpha basket" ? "basket" : "basket-pro"}
                            className={`${style.e_heading_wrapper} position-relative`}>
                            <img src={require(props.product.strategy_type === "alpha basket" ? "../../Assets/Images/Card/alphabasket-tag.svg" : "../../Assets/Images/Card/alphabasket-pro-tag.svg").default}
                                draggable={false}
                                className='position-absolute left--6px top-8px h-28'
                                alt='tag' />
                            <Chip label={props.product.risk_category_info.risk_category_name}
                                className={props.product.risk_category_info.risk_category_name === 'Conservative' ? 'e-text-deep-green e-bg-nyanza e-border-1px-light-green' :
                                    props.product.risk_category_info.risk_category_name === 'Moderate' ? 'e-text-brown e-bg-lemon-chiffon e-border-1px-jasmine' :
                                        'e-text-cadmium-purple e-bg-lavender-blush e-border-1px-light-red'} />
                        </div>
                        <div className='p-3'>
                            <div className='d-flex align-items-center gap-12px pb-3'>
                                <img src={require("../../Assets/Images/Card/product-icon.svg").default}
                                    draggable={false}
                                    width={48}
                                    className='border-radius-4 bg-white p-1'
                                    alt='product' />
                                <div>
                                    <p className='e-font-14-res mb-1 e-text-black e-alt-font-lato e-font-16 e-font-weight-600 line-height-20px'>
                                        {props.product.strategy_name}
                                    </p>
                                    <p className='e-font-12-res mb-0 e-text-philippine-gray e-alt-font-lato e-font-14 e-font-weight-400 line-height-18px text-decoration-hover-underline'
                                        onClick={(event) => _handleNavigateToCreatorDetail(event, props.product.creator_id)}>
                                        {props.product.creator_name}
                                    </p>
                                </div>
                            </div>

                            {/* basket details */}
                            {/* <div className='row row-gap-3 pb-3 e-border-bottom-1px-anti-flash-white justify-content-between'> */}
                            <div className='row row-gap-3 justify-content-between'>
                                <div className='col-auto'>
                                    <p className='mb-1 e-text-outer-space e-alt-font-lato e-font-14 e-font-weight-400 line-height-18px'>
                                        First Invested on
                                    </p>
                                    <p className={`e-font-14-res mb-0 e-text-chinese-black e-alt-font-lato e-font-16 e-font-weight-600 line-height-20px e-letter-spacing-min-point-1px`}>
                                        {props.product.created_on}
                                    </p>
                                </div>
                                <div className='col-auto'>
                                    <p className='mb-2 e-text-outer-space e-alt-font-lato e-font-14 e-font-weight-400 line-height-18px'>
                                        Order status
                                    </p>
                                    <p className={`d-flex gap-1 align-items-center mb-0 e-alt-font-lato e-font-14 e-font-weight-600 line-height-16px
                                        ${props.product.status === "Success" ? "e-text-go-green" : (props.product.status === "Partially Completed" || props.product.status === "Pending") ? "e-text-marigold" : "e-text-paradise-pink"}`}>
                                        <Icon icon={props.product.status === "Success" ? "success-icon" : (props.product.status === "Partially Completed" || props.product.status === "Pending") ? "processing-icon" : "failed-icon"}
                                            size="16px" />
                                        {props.product.status}
                                    </p>
                                </div>
                                {/* <div className='col-auto'>
                                        <p className='mb-1 e-text-outer-space e-alt-font-lato e-font-14 e-font-weight-400 line-height-18px'>
                                            Order Amount
                                        </p>
                                        <p className={`e-font-14-res mb-0 e-text-chinese-black e-alt-font-lato e-font-16 e-font-weight-600 line-height-20px e-letter-spacing-min-point-1px`}>
                                            ₹{props.product.total_order_amount.toLocaleString("en-IN")}
                                        </p>
                                    </div> */}
                                {/* <div className='col-auto'>
                                        <p className='mb-1 e-text-outer-space e-alt-font-lato e-font-14 e-font-weight-400 line-height-18px'>
                                            Order Type
                                        </p>
                                        <Chip label={props.product.order_type}
                                            className={
                                                props.product.order_type === 'SIP First Installment' ? 'e-text-deep-green e-bg-nyanza e-border-1px-light-green' :
                                                    props.product.order_type === 'SIP Installment' ? 'e-text-brown e-bg-lemon-chiffon e-border-1px-jasmine' :
                                                        props.product.order_type === 'Lumpsum' ? 'e-text-absolute-zero e-bg-light-cyan e-border-1px-non-photo-blue' :
                                                            'e-text-cadmium-purple e-bg-lavender-blush e-border-1px-light-red'} />
                                    </div> */}
                            </div>
                            {/* <div className='row pt-3 justify-content-between'>
                                    <div className='col-auto'>
                                        <p className='mb-2 e-text-outer-space e-alt-font-lato e-font-14 e-font-weight-400 line-height-18px'>
                                            Payment status
                                        </p>
                                        <p className={`d-flex gap-1 align-items-center mb-0 e-alt-font-lato e-font-14 e-font-weight-600 line-height-16px
                                         ${props.product.payment_status === "Success" ? "e-text-go-green" : props.product.payment_status === "Processing" ? "e-text-marigold" : "e-text-paradise-pink"}`}>
                                            <Icon icon={props.product.payment_status === "Success" ? "success-icon" : props.product.payment_status === "Processing" ? "processing-icon" : "failed-icon"}
                                                size="16px" />
                                            {props.product.payment_status}
                                        </p>
                                    </div>
                                    <div className='col-auto'>
                                        <p className='mb-2 e-text-outer-space e-alt-font-lato e-font-14 e-font-weight-400 line-height-18px'>
                                            Order status
                                        </p>
                                        <p className={`d-flex gap-1 align-items-center mb-0 e-alt-font-lato e-font-14 e-font-weight-600 line-height-16px
                                        ${props.product.status === "Success" ? "e-text-go-green" : props.product.status === "Pending" ? "e-text-marigold" : "e-text-paradise-pink"}`}>
                                            <Icon icon={props.product.status === "Success" ? "success-icon" : props.product.status === "Pending" ? "processing-icon" : "failed-icon"}
                                                size="16px" />
                                            {props.product.status}
                                        </p>
                                    </div>
                            </div> */}
                        </div>
                    </div>
                </div>
                :
                props.type == 3 ?
                    <div className={`${style.e_alphabasket_card_wrapper} cursor-pointer `}
                        onClick={() => props.handleClick()}>
                        <div className='e-bg-white border-radius-16'>
                            <div data-type={"basket"}
                                className={`${style.e_heading_wrapper} position-relative`}>
                                <img src={require("../../Assets/Images/Card/alphabasket-tag.svg").default}
                                    draggable={false}
                                    className='position-absolute left--6px top-8px h-28'
                                    alt='tag' />

                                <div className='position-absolute end-0 top-8px h-24 e-text-chinese-black e-bg-tag-color border-radius-16 rounded-end-0 px-2 d-flex e-alt-font-lato e-font-14 e-font-weight-500'>
                                    <span className='pe-1'>
                                        Execution Partner :
                                    </span>
                                    <span className='flex-fill h-auto e-text-primary-color'>
                                        {props.product.execution_partner}
                                    </span>
                                </div>
                                {
                                    // props.product.strategy_type &&
                                    // <Chip label={props.product.strategy_type || "--"}
                                    //     className={props.product.strategy_type === 'Conservative' ? 'e-text-deep-green e-bg-nyanza e-border-1px-light-green' :
                                    //         props.product.strategy_type === 'Moderate' ? 'e-text-brown e-bg-lemon-chiffon e-border-1px-jasmine' :
                                    //             'e-text-cadmium-purple e-bg-lavender-blush e-border-1px-light-red'} />
                                }
                            </div>
                            <div className='p-3'>
                                <div className='d-flex align-items-center gap-12px e-border-bottom-1px-anti-flash-white pb-3'>
                                    <img src={props.product.strategy_icon}
                                        draggable={false}
                                        width={48}
                                        className={`${props.product.strategy_icon ? "" : "invisible"} border-radius-4 bg-white object-fit-contain`}
                                        alt='product' />
                                    <div>
                                        <p className='e-font-14-res mb-1 e-text-black e-alt-font-lato e-font-16 e-font-weight-600 line-height-20px'>
                                            {props.product.strategy_name}
                                        </p>
                                        <p className='e-font-12-res mb-0 e-text-philippine-gray e-alt-font-lato e-font-14 e-font-weight-400 line-height-18px text-decoration-hover-underline'
                                            onClick={(event) => _handleNavigateToCreatorDetail(event, props.product.creator_id)}>
                                            by {props.product.creator_name || "--"}
                                        </p>
                                    </div>
                                </div>

                                {/* basket details */}
                                <div className='pt-2'>
                                    <div className='row justify-content-between'>
                                        <div className='col-auto'>
                                            <p className='mb-1 e-text-outer-space e-alt-font-lato e-font-12 e-font-weight-400 line-height-18px'>
                                                Current value
                                            </p>
                                            <p className={`e-text-chinese-black e-font-14-res mb-0 e-alt-font-lato e-font-16 e-font-weight-600 line-height-20px`}>
                                                ₹{props.product.current_value.toLocaleString("en-IN")}
                                            </p>
                                        </div>
                                        <div className='col-auto'>
                                            <p className='mb-1 e-text-outer-space e-alt-font-lato e-font-12 e-font-weight-400 line-height-18px'>
                                                Invested Amount
                                            </p>
                                            <p className={`e-text-chinese-black e-font-14-res mb-0 e-alt-font-lato e-font-16 e-font-weight-600 line-height-20px`}>
                                                ₹{props.product.investment_value.toLocaleString("en-IN")}
                                            </p>
                                        </div>
                                        <div className='col-auto '>
                                            <p className='text-end mb-1 e-text-outer-space e-alt-font-lato e-font-12 e-font-weight-400 line-height-18px'>
                                                {props.product.returns_data.label}
                                            </p>
                                            <p className={`${Number(props.product.returns_data.value) >= 0 ? "e-text-islamic-green-light" : "e-text-red"} e-font-14-res mb-0 e-alt-font-lato e-font-16 e-font-weight-600 line-height-20px`}>
                                                {props.product.returns_data.value_str}
                                                {/* {
                                                    props.product.returns_data.label === "Returns" &&
                                                    <span className="e-font-12 line-height-20px">
                                                        ({props.product.returns_per}%)
                                                    </span>
                                                } */}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    props.type == 4 ?
                        <div className={`${style.e_alphabasket_card_wrapper} cursor-pointer h-100`}
                            onClick={() => props.handleClick()}>
                            <div className='e-bg-white border-radius-16 h-100'>
                                <div data-type={props.category === 1 ? "basket" : "basket-pro"}
                                    className={`${style.e_heading_wrapper} position-relative`}>
                                    <img src={require(props.category === 1 ? "../../Assets/Images/Card/alphabasket-tag.svg" : "../../Assets/Images/Card/alphabasket-pro-tag.svg").default}
                                        draggable={false}
                                        className='position-absolute left--6px top-8px h-28'
                                        alt='tag' />
                                </div>
                                <div className='p-3'>
                                    <div className='d-flex flex-wrap flex-lg-nowrap  align-items-center gap-12px e-border-bottom-1px-anti-flash-white pb-3'>
                                        <img src={props.product.strategy_icon}
                                            draggable={false}
                                            className='border-radius-4 bg-white object-fit-contain'
                                            width={48}
                                            alt={props.product.strategy_name} />
                                        <div>
                                            <p className='e-font-14-res mb-1 e-text-black e-alt-font-lato e-font-16 e-font-weight-600 line-height-20px'>
                                                {props.product.strategy_name}
                                            </p>
                                            <Chip label={props.product.risk_category_info?.risk_category_name}
                                                className={props.product.risk_category_info?.risk_category_name === 'Conservative' ? 'e-text-deep-green e-bg-nyanza e-border-1px-light-green' :
                                                    props.product.risk_category_info?.risk_category_name === 'Moderate' ? 'e-text-brown e-bg-lemon-chiffon e-border-1px-jasmine' :
                                                        'e-text-cadmium-purple e-bg-lavender-blush e-border-1px-light-red'} />

                                        </div>
                                        <PrimaryButton name="Invest"
                                            padding="px-5 padding-16px-tb"
                                            className="ms-auto"
                                            onPress={() => { }} />

                                    </div>

                                    {/* basket details */}
                                    <div className='pt-2'>
                                        <div className='row justify-content-between row-gap-4'>
                                            {
                                                props.product.cagr.value ?
                                                    <div className='col-auto'>
                                                        <p className='mb-1 e-text-outer-space e-alt-font-lato e-font-12 e-font-weight-400 line-height-18px'>
                                                            {props.product.cagr.label} CAGR
                                                        </p>
                                                        <p className={`${props.product.cagr.value >= 0 ? "e-text-islamic-green-light" : "e-text-red"} e-font-14-res mb-0 e-alt-font-lato e-font-16 e-font-weight-600 line-height-20px`}>
                                                            {props.product.cagr.value_str}
                                                        </p>
                                                    </div>
                                                    :
                                                    ""
                                            }

                                            <div className='col-auto'>
                                                <p className='mb-1 e-text-outer-space e-alt-font-lato e-font-12 e-font-weight-400 line-height-18px'>
                                                    Min. Investment
                                                </p>
                                                {
                                                    props.product.min_investment &&
                                                    <p className={`e-font-14-res mb-0 e-text-chinese-black e-alt-font-lato e-font-16 e-font-weight-600 line-height-20px`}>
                                                        ₹{Number(props.product.min_investment).toLocaleString("en-IN")}
                                                    </p>
                                                }
                                            </div>
                                            <div className='col-auto'>
                                                <p className='mb-1 e-text-outer-space e-alt-font-lato e-font-12 e-font-weight-400 line-height-18px'>
                                                    Objective
                                                </p>
                                                <p className={`text-nowrap e-font-14-res mb-0 e-text-chinese-black e-alt-font-lato e-font-16 e-font-weight-600 line-height-20px`}>
                                                    {props.product.objective}
                                                </p>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        null
    )
}

export default AlphaBasketCard;

AlphaBasketCard.defaultProps = {
    type: 1,
    handleClick: () => { }
}